/* Angular Component */
import { Component, Input } from "@angular/core";
import { UserService } from "../../../domain/user-service";
import { MediaItem } from "../../../domain/media";

@Component({
  selector: "duration",
  templateUrl: "./duration.component.html",
  styleUrls: ["./duration.component.scss"],
})
export class DurationComponent {
  @Input()
  origin;

  @Input()
  mediaItem: MediaItem;

  readable = ""; // 00:04:00:00 (25 fps)
  channelFramerate: number;

  constructor(private userService: UserService) {}

  /**
   * Detect Changes and performing actions according to it
   * @param changes
   * @return void
   */
  ngOnChanges(changes) {
    if (changes["origin"] && changes["origin"]["currentValue"] != null) {
      this.origin = changes["origin"]["currentValue"];
      this.parseOrigin();
    }

    if (changes["mediaItem"] && changes["mediaItem"]["currentValue"] != null) {
      this.parseMediaItem();
    }
  }

  /**
   * Parsing Origin and make it working
   * @return void
   */
  parseOrigin() {
    if (typeof this.origin == "undefined") return;

    const duration = parseInt("" + this.origin / 1000);

    const days = duration / (24 * 60 * 60);
    const hours = (duration / (60 * 60)) % 24;
    const minutes = (duration / 60) % 60;
    const seconds = duration % 60;

    this.readable =
      this.fixNumber(hours) +
      ":" +
      this.fixNumber(minutes) +
      ":" +
      this.fixNumber(seconds);
  }

  /**
   * Parsing Duration based on media item
   * @return void
   */
  parseMediaItem() {
    this.readable = this.mediaItem.formatDuration(this.channelFramerate);
  }

  /**
   * Fixing number (adding zero before digit)
   * @param number
   * @return string
   */
  fixNumber(number) {
    number = parseInt(number);
    return number < 10 ? "0" + number : number;
  }

  ngOnInit() {
    // console.log("Duration:", this.origin, this.mediaItem);

    this.userService.getCurrentChannel().then((currentChannel) => {
      this.channelFramerate = currentChannel.framerate;
    });
  }
}
